import {
  Box,
  Link,
  List,
  ListItemText,
  Typography,
  styled
} from '@mui/material';

export const UserMenuContainer = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: inherit;
  max-height: inherit;
  padding-bottom: ${theme.spacing(2)};
  background-color: ${theme.inferiorMenu.background};
`
);

export const UserBoxText = styled(Box)(
  ({ theme }) => `
    width: 100%;
    text-align: left;
    padding-left: ${theme.spacing(1)};
  `
);

export const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
  font-weight: ${theme.typography.fontWeightBold};
  color: ${theme.inferiorMenu.menuItemColor};
  display: block;
  `
);

export const UserMenuTopWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const UserMenuHeaderWrapper = styled(Box)(
  ({ theme }) => `
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing(0, 1.8, 3, 1.8)};
  background-color: ${theme.inferiorMenu.userMenuBg};
`
);

export const AvatarWrapper = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const GoBackLink = styled(Link)(
  ({ theme }) => `
  font-weight: ${theme.typography.fontWeightBold};
  align-self: flex-start;
  underline: none; 
  `
);

export const AccountItemText = styled(ListItemText)(
  ({ theme }) => `
  padding-left: ${theme.spacing(1.8)};
  padding-bottom: ${theme.spacing(1)};
  color: ${theme.inferiorMenu.menuItemColor};
  `
);

export const UserMenuBottomWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: ${theme.spacing(2)};
  background-color: ${theme.inferiorMenu.background};
  `
);

export const MenuItemsList = styled(List)(
  ({ theme }) => `
  padding: ${theme.spacing(2, 0, 0, 0)};
  background-color: ${theme.inferiorMenu.background};
  `
);
